import {COLORS} from 'frontend/utils/color_palettes';

import {DefaultMapMarker, IconSize} from './default';

const BATTERY_COLOR = COLORS.NewIndigo.get(50);

/**
 * Marker represents buttery on a map.
 */
export class BatteryMapMarker extends DefaultMapMarker {
  protected override getDefaultIcon(size: IconSize, opacity = 1): string {
    return batterySVG(size, opacity);
  }

  protected override getRaisedIcon(size: IconSize, opacity = 1): string | null {
    return batteryRaisedSVG(size, opacity);
  }
}

function batterySVG(size: number, opacity = 1, color = BATTERY_COLOR): string {
  return `
<svg width="${size}" height="${size}" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path d="M12 24C5.37261 24 3.03727e-05 18.6274 3.05176e-05 12C3.06624e-05 5.37258 5.37261 -1.44847e-07 12 0C18.6274 1.44847e-07 24 5.37258 24 12C24 18.6274 18.6274 24 12 24Z" fill="white"/>
  <rect x="2" y="2" width="20" height="20" rx="10" fill="${color}" opacity="${opacity}"/>
  <path d="M9.59994 18.4C9.37772 18.4 9.18883 18.3222 9.03327 18.1667C8.87772 18.0111 8.79994 17.8222 8.79994 17.6V7.6C8.79994 7.37778 8.87772 7.18889 9.03327 7.03333C9.18883 6.87778 9.37772 6.8 9.59994 6.8H10.7999V5.6H13.1999V6.8H14.3999C14.6222 6.8 14.8111 6.87778 14.9666 7.03333C15.1222 7.18889 15.1999 7.37778 15.1999 7.6V17.6C15.1999 17.8222 15.1222 18.0111 14.9666 18.1667C14.8111 18.3222 14.6222 18.4 14.3999 18.4H9.59994ZM9.99994 17.2H13.9999V8H9.99994V17.2Z" fill="white"/>
</svg>`;
}

function batteryRaisedSVG(size: number, opacity = 1, color = BATTERY_COLOR): string {
  return `
<svg width="${size}" height="${size}" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
  <path d="M16 32C7.16345 32 3.27188e-06 24.8366 3.46501e-06 16C3.65814e-06 7.16344 7.16345 -5.4282e-07 16 -3.49691e-07C24.8366 -1.56562e-07 32 7.16344 32 16C32 24.8366 24.8366 32 16 32Z" fill="white"/>
  <rect x="4" y="4" width="24" height="24" rx="12" fill="${color}" opacity="${opacity}"/>
  <path d="M13 24C12.7222 24 12.4861 23.9028 12.2917 23.7083C12.0972 23.5139 12 23.2778 12 23V10.5C12 10.2222 12.0972 9.98611 12.2917 9.79167C12.4861 9.59722 12.7222 9.5 13 9.5H14.5V8H17.5V9.5H19C19.2778 9.5 19.5139 9.59722 19.7083 9.79167C19.9028 9.98611 20 10.2222 20 10.5V23C20 23.2778 19.9028 23.5139 19.7083 23.7083C19.5139 23.9028 19.2778 24 19 24H13ZM13.5 22.5H18.5V11H13.5V22.5Z" fill="white"/>
</svg>`;
}
